import Vue from 'vue';
import WorkUnit from '@/components/global_components/unit/WorkUnit';
import WorkPublicUnit from '@/components/global_components/unit/WorkPublicUnit';
import WorkEntryUnit from '@/components/global_components/unit/WorkEntryUnit';
import WorkTableUnit from '@/components/global_components/unit/WorkTableUnit';
import WorkBaseLevelTableLookALikeUnit from '@/components/global_components/unit/WorkBaseLevelTableLookALikeUnit';
import WorkFilesUnit from '@/components/global_components/unit/WorkFilesUnit';

Vue.component('WUnit', WorkUnit);
Vue.component('WEntryUnit', WorkEntryUnit);
Vue.component('WTableUnit', WorkTableUnit);
Vue.component('WFilesUnit', WorkFilesUnit);
Vue.component('WPublicUnit', WorkPublicUnit);
Vue.component('WBaseLevelTableLookALikeUnit', WorkBaseLevelTableLookALikeUnit);
